import React from "react";
import { useSelector } from "react-redux";
import isEmpty from "lodash/isEmpty";

import { AlertText, alertTypes } from "shared/dist/components";
import { orgIdAvailability } from "./content";
import classes from "../Organization.module.css";

const OrganizationIdAvailability = ({ orgDetails, id, availability }) => {
    const isValidateValidateIdLoading = useSelector(
        (state) => state.loader.validateOrgId.isLoading
    );

    if (!Boolean(orgDetails.id)) {
        return null;
    }
    if (isValidateValidateIdLoading) {
        return (
            <div className={classes.alertTextContainer}>
                <AlertText type={alertTypes.INFO} message="validating..." />
            </div>
        );
    }

    const type =
        availability === orgIdAvailability.AVAILABLE ? alertTypes.SUCCESS : alertTypes.ERROR;

    const message =
        !isEmpty(id) && Boolean(availability) ? `Organization Id is ${availability}` : "";

    return (
        <div className={classes.alertTextContainer}>
            <AlertText type={type} message={message} />
        </div>
    );
};

export default OrganizationIdAvailability;
